const baseUrl = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

/** Save the visitor's first / last name on the scanned ticket. */
export const updateTicketNamesApi = async (ticketId, data) => {
  try {
    const response = await fetch(
      `${baseUrl}/user/payment/update-ticket?ticketId=${encodeURIComponent(ticketId)}`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        error: errorData.message || `HTTP error! status: ${response.status}`,
        message: errorData.message,
        statusCode: response.status,
      };
    }

    const responseData = await response.json().catch(() => ({}));
    return { success: true, data: responseData, message: responseData.message };
  } catch (error) {
    return { success: false, error: error?.message || 'Network error' };
  }
};
